export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";